/* eslint-disable react/no-unknown-property */
import { Html } from '@react-three/drei';
import classNames from 'classnames';
import { PointerEventHandler, useEffect } from 'react';
import Styles from './style.module.scss';
import gsap from 'gsap';

type Props = {
  name: string;
  position: Array<number>;
  status?: boolean;
  colorIndex?: number;
  openStatu?: boolean;
  //orbit?: any;
  oclusionObj: any;
  setButtonAction?: PointerEventHandler<HTMLButtonElement>;
};

const Marker = ({
  name,
  position,
  status = false,
  colorIndex = 0,
  openStatu = false,
  // orbit,
  oclusionObj,
  setButtonAction = () => {},
}: Props) => {
  return (
    <group>
      {/* <TransformControls ref={transform}> */}
      <mesh name={name}>
        <Html
          sprite
          occlude={[oclusionObj]}
          position={[position[0], position[1], position[2]]}
        >
          <div
            id={'marker'}
            className={Styles.wrapper}
            style={{ display: status ? 'block' : 'none' }}
          >
            <button
              id={'markButton'}
              className={classNames(
                Styles.button,
                {
                  [Styles.sky]: colorIndex === 0,
                },
                {
                  [Styles.green]: colorIndex === 1,
                },
                {
                  [Styles.steel]: colorIndex === 2,
                },
                {
                  [Styles.gray]: colorIndex === 3,
                },
                {
                  [Styles.clickedStatu]: openStatu === true,
                }
              )}
              style={{
                padding: openStatu ? 5 : 2,
              }}
              onClick={setButtonAction}
            >
              <p id={'plusMark'} className={Styles.symbol}>
                {'+'}
              </p>
              {name !== '' ? (
                <p
                  id={'textInfo'}
                  className={classNames(Styles.info, {
                    [Styles.clickedStatu]: openStatu === true,
                  })}
                >
                  &nbsp;{name}
                </p>
              ) : null}
            </button>
            <span
              className={classNames(
                Styles.animateEffect,
                {
                  [Styles.sky]: colorIndex === 0,
                },
                {
                  [Styles.green]: colorIndex === 1,
                },
                {
                  [Styles.steel]: colorIndex === 2,
                },
                {
                  [Styles.gray]: colorIndex === 3,
                },
                {
                  [Styles.effectNone]: openStatu === true,
                }
              )}
            ></span>
          </div>
        </Html>
      </mesh>
      {/* </TransformControls> */}
    </group>
  );
};

export default Marker;
